<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="1000"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="text"
          :label="label"
          readonly
          :dense="dense"
          v-on="on"
          :error-messages="errorMessages"
        >
          <template slot="append">
            <v-btn
              icon
              v-if="clearable && !readonly && text"
              @click="clearClick"
            >
              <v-icon>{{ icon.clear }}</v-icon>
            </v-btn>
            <v-icon v-if="!readonly" @click="menu = true">{{
              icon.search
            }}</v-icon>
            <v-icon
              v-if="value && showLink"
              :color="feature.sites.color"
              @click="showSiteCardClick"
            >
              {{ icon.site }}
            </v-icon>
          </template>
        </v-text-field>
      </template>
      <SiteSearch v-if="!readonly" :searchText="text" @select="onSelect" />
    </v-menu>

    <v-dialog v-model="showSiteCardDialog" :width="feature.sites.dialogWidth">
      <SiteCard
        :siteId="value"
        :isDialogOpen="showSiteCardDialog"
        :isServiceEditEnabled="isServiceEditEnabled"
        @update="siteCardCloseEvent"
        @close="siteCardCloseEvent"
      />
    </v-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
import { icon, feature } from '@/use/Constants'
import SiteSearch from '@/components/Site/SiteSearch'
import SiteCard from '@/components/Site/SiteCard'

export default {
  name: 'SitePicker',
  components: { SiteSearch, SiteCard },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isServiceEditEnabled: {
      type: Boolean,
      default: true
    },
    showLink: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const menu = ref(false)
    const showSiteCardDialog = ref(false)
    const siteCardData = ref()

    const showSiteCardClick = async () => {
      showSiteCardDialog.value = true
    }

    const siteCardCloseEvent = () => {
      showSiteCardDialog.value = false
    }

    const onSelect = event => {
      context.emit('input', event.SiteId)
      context.emit('update:text', event.SiteName)
      menu.value = false
    }

    const clearClick = () => {
      context.emit('input', null)
      context.emit('update:text', null)
    }

    return {
      menu,
      clearClick,
      onSelect,
      siteCardData,
      showSiteCardDialog,
      showSiteCardClick,
      siteCardCloseEvent,
      feature,
      icon
    }
  }
}
</script>

<style lang="scss" scoped></style>
